import { render } from "./StatusBar.vue?vue&type=template&id=61b98834"
import script from "./StatusBar.vue?vue&type=script&lang=js"
export * from "./StatusBar.vue?vue&type=script&lang=js"

import "./StatusBar.vue?vue&type=style&index=0&id=61b98834&lang=scss"

import exportComponent from "E:\\projects\\EUP_BITBUCKET\\edriver_chat\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__